Controller = App.loadClass 'core::Angular/Controller'

class exports.NutrientManagementToolsController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service) ->
        # Get the default values based on fertilizer form inputs, all done behind the scenes
        @service.getManagementTechniquesDefaults()
        super

    togglePractice: (practice, key) =>
        if @practiceIsSelected(practice, key)
            _.remove(@service.fpcResult.data[key], (item) => return item is practice)
            return @showConservationAlert = false

        return @service.fpcResult.data[key].push practice

    practiceIsSelected: (practice, key) =>
        return _.find(@service.fpcResult.data[key], (item) => return item is practice)
